/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as action from '../actions'
import Header from '../components/Header';
import { playAudioInit } from '../utils/covid/TestPageUtil';
import Selfie from '../assets/images/selfie.png';
import Someone from '../assets/images/someone.png';
import Upload from '../assets/images/upload.png';
import '../styles/intermediary.css';

export default function Intermediary(props) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(action.isRefresh({ isNotRefresh: true }))
    },[])
    
    async function testWithMyself() {
        window.audioInstance = await playAudioInit()
        props.history.push({
            pathname: '/testWithCamera',
            state: { iselfie: true, isDemo: props?.location?.state?.isDemo }
        });
    }

    async function testWithSomeone() {
        window.audioInstance = await playAudioInit()
        props.history.push({
            pathname: '/testWithCamera',
            state: { iselfie: false, isDemo: props?.location?.state?.isDemo }
        });
    }

    function testWithUpload() {
        props.history.push({
            pathname: '/testWithUpload',
            state: { isDemo: props?.location?.state?.isDemo }
        });
    }

    return (
        <div className="main container" data-testid="intermediary-container">
            <Header/>
            <div className="test-option">
                <p className="mt-5 heading">Who will do the test?</p>
                <div className="buttons-div mt-3">
                    <div id='testWithMyself' data-testid="test_myself" className='button' onClick={testWithMyself}>
                        <img src={Selfie} alt='covid-test'/>
                        <div>
                            <span>Myself</span>
                        </div>
                        <div className="inter-small-font">
                            <span>(Automatic shots for first time users)</span>
                        </div>
                    </div>
                    <div id='testWithSomeone' data-testid="testWithSomeone" className='button' onClick={testWithSomeone}>
                        <img src={Someone} alt='covid-test'/>
                        <div>
                            <span>Someone else</span>
                        </div>
                        <div className="inter-small-font">
                            <span>(Automatic shots for testing loved ones)</span>
                        </div>
                    </div>
                    <div id='testWithUpload' data-testid="testWithUpload" className='button' onClick={testWithUpload}>
                        <img src={Upload} alt='cardio'/>
                        <div>
                            <span>Pro upload</span>
                        </div>
                        <div className="inter-small-font">
                            <span>(Manual shots for pro users)</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
